import { render } from "./QueryPage.vue?vue&type=template&id=b1bbeb08&scoped=true"
import script from "./Query.js?vue&type=script&lang=js&external"
export * from "./Query.js?vue&type=script&lang=js&external"

import "./QueryPage.vue?vue&type=style&index=0&id=b1bbeb08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1bbeb08"]])

export default __exports__